/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PaymentCorpoClientSecretMutationVariables = {|
  corpoRef: string
|};
export type PaymentCorpoClientSecretMutationResponse = {|
  +payment: ?{|
    +corpo: ?{|
      +res: ?{|
        +code: number,
        +message: string,
        +data: ?any,
      |}
    |}
  |}
|};
export type PaymentCorpoClientSecretMutation = {|
  variables: PaymentCorpoClientSecretMutationVariables,
  response: PaymentCorpoClientSecretMutationResponse,
|};
*/


/*
mutation PaymentCorpoClientSecretMutation(
  $corpoRef: String!
) {
  payment {
    corpo {
      res: createSEPASetupIntent(corpoRef: $corpoRef) {
        code
        message
        data
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "corpoRef"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PaymentMutation",
    "kind": "LinkedField",
    "name": "payment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PaymentCorpoMutation",
        "kind": "LinkedField",
        "name": "corpo",
        "plural": false,
        "selections": [
          {
            "alias": "res",
            "args": [
              {
                "kind": "Variable",
                "name": "corpoRef",
                "variableName": "corpoRef"
              }
            ],
            "concreteType": "PaymentPaymentPayload",
            "kind": "LinkedField",
            "name": "createSEPASetupIntent",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "data",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentCorpoClientSecretMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PaymentCorpoClientSecretMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b0e75aa018bf81af65f71ef1bab0310b",
    "id": null,
    "metadata": {},
    "name": "PaymentCorpoClientSecretMutation",
    "operationKind": "mutation",
    "text": "mutation PaymentCorpoClientSecretMutation(\n  $corpoRef: String!\n) {\n  payment {\n    corpo {\n      res: createSEPASetupIntent(corpoRef: $corpoRef) {\n        code\n        message\n        data\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '15d59a6a96b0d2662ffc3aaeb638e8e6';

module.exports = node;
